import { Injectable, inject } from '@angular/core';
import { combineLatest, Observable, switchMap } from 'rxjs';
import { HttpService } from '@boels/helpers';
import { BoelsCatalogsResponse, ParamsModel } from '@boels/models';
import { SiteContextFacade } from './../../site-context/facade/site-context.facade';
import { CultureFacade } from './../../cultures/facade/cultures.facade';

@Injectable({
  providedIn: 'any',
})
export class CatalogsGateway {
  private httpService = inject(HttpService);
  private siteContextFacade = inject(SiteContextFacade);
  private cultureFacade = inject(CultureFacade);

  getCatalogs(baseSiteId: string): Observable<BoelsCatalogsResponse> {
    return combineLatest([
      this.cultureFacade.getActiveLanguage(),
      this.cultureFacade.getActiveCurrency(),
    ]).pipe(
      switchMap(([lang, currency]) => {
        const params: ParamsModel = [
          ['fields', 'DEFAULT'],
          ['lang', lang],
          ['curr', currency],
        ];
        return this.httpService.get<BoelsCatalogsResponse>(
          `${baseSiteId}/catalogs`,
          params,
        );
      }),
    );
  }
}
